import { atom } from 'jotai';

export const automaticNavigationDisabledAtom = atom<boolean>(false);
